import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import optionsTextEnriched from '../../../../shared/utils/optionsTextEnriched'
import "./data-policy.scss"
import useDataPolicy from '../../hooks/useDataPolicy'

const DataPolicy = () => {

  const { dataPolicy } = useDataPolicy()


  return (
    <div className="f-data-policy">
      {documentToReactComponents(JSON.parse( dataPolicy.raw ), optionsTextEnriched)}
    </div>
  )
}

export default DataPolicy
